import React, { useEffect, useId, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import CodeInput from "../../Login/mfa/CodeInput";
import "./security.css";

const HINTS = {
  totp: "Open your authenticator app and enter the 6-digit code for LoanlinQ.",
  email: "We emailed you a 6-digit code.",
};

// Only an emailed code can be resent; the authenticator app makes its own.
const StepUpModal = ({ open, method, methods, busy, error, onSelectMethod, onSubmit, onCancel, onResend }) => {
  const [code, setCode] = useState("");
  const titleId = useId();

  useEffect(() => setCode(""), [method]);

  return (
    <Modal show={open} animation={false} backdrop="static" onHide={onCancel} aria-labelledby={titleId} className="mfa-modal">
      <Modal.Header>
        <Modal.Title id={titleId}>Confirm it&apos;s you</Modal.Title>
        <span className="mfa-modal-sub">Needed before any change to your sign-in settings.</span>
      </Modal.Header>
      <Modal.Body>
        <p>{HINTS[method]}</p>
        <CodeInput method={method} value={code} onChange={setCode} disabled={busy}
          onResend={method === "email" ? onResend : undefined} />
        {error && <div className="alert alert-danger mb-0" role="alert">{error}</div>}
        {methods.filter((item) => item !== method).map((item) => (
          <div key={item}>
            <Button variant="link" type="button" className="p-0" disabled={busy} onClick={() => onSelectMethod(item)}>
              Use {item === "totp" ? "authenticator app" : "email"} instead
            </Button>
          </div>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" className="mfa-btn-quiet" type="button" disabled={busy} onClick={onCancel}>Cancel</Button>
        <Button type="button" className="text-white fw-bold" disabled={busy} onClick={() => onSubmit(code)}>Verify</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default StepUpModal;
